import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { Vista } from './components/Vistas';

const ReporteVentasPage: FC = () => {
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '/reportes/reporte-ventas',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Reporte de Ventas</PageTitle>
      <Vista />
    </>
  );
};

export { ReporteVentasPage };
